import React from "react";
import styles from "./Footer.module.css";
import { Container } from "../Container";

interface FooterProps {
  onNavigate?: (sectionId: string) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (sectionId: string) => {
    if (onNavigate) {
      onNavigate(sectionId);
    }
  };

  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.footerContent}>
          {/* Company Info */}
          <div className={styles.footerSection}>
            <h3 className={styles.footerHeading}>Domonique Dixon</h3>
            <p className={styles.footerText}>
              Indie iOS developer. I design, build, and ship apps from concept to App Store.
            </p>
          </div>

          {/* Quick Links */}
          <div className={styles.footerSection}>
            <h3 className={styles.footerHeading}>Quick Links</h3>
            <ul className={styles.footerLinks}>
              <li>
                <button
                  onClick={() => handleNavClick("hero")}
                  className={styles.footerLink}
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("about")}
                  className={styles.footerLink}
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("portfolio")}
                  className={styles.footerLink}
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick("contact")}
                  className={styles.footerLink}
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          {/* <div className={styles.footerSection}>
            <h3 className={styles.footerHeading}>Legal</h3>
            <ul className={styles.footerLinks}>
              <li>
                <button onClick={() => handleNavClick('privacy')} className={styles.footerLink}>
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div> */}
        </div>

        {/* Copyright */}
        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
            &copy; {currentYear} Domonique Dixon. All rights reserved.
          </p>
          <a
            href="https://x.com/domdixonapp"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.xLink}
          >
            @domdixonapp
          </a>
        </div>
      </Container>
    </footer>
  );
};
